import { render, staticRenderFns } from "./CreateQuotaCIBDialog.vue?vue&type=template&id=b62c585e"
import script from "./CreateQuotaCIBDialog.vue?vue&type=script&lang=js"
export * from "./CreateQuotaCIBDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports